import glassbuilding from './assets/glassbuilding.png'
import { CenterBox, ContentSpan, GoldenSpan, PhotoFrame, SectionTitle, SoulFigureSummary } from './compnents'
import COO from './assets/COO.png'
import CEO from './assets/CEO.png'
import CCO from './assets/CCO.png'
import culture from './assets/culture.png'
import history from './assets/history.png'
import staff1 from './assets/staff1.jpg'
import staff2 from './assets/staff2.jpg'
import staff3 from './assets/staff3.jpg'
import staff4 from './assets/staff4.jpg'
import staff5 from './assets/staff5.jpg'
import staff6 from './assets/staff6.jpg'
import staff7 from './assets/staff7.jpg'
import staff8 from './assets/staff8.jpg'
import whitespace from './assets/whitespace.png'

export const CompanyProfiles = () => {
    const staffPhotos1 = [
        { 'photo': staff1, 'width': 291, 'cations': ['创始人在清华五道口金融学院学习期间', '作为学生代表向吴晓灵院长献花'] },
        { 'photo': whitespace, 'width': 5, 'cations': [] },
        { 'photo': staff2, 'width': 615, 'cations': ['公司员工大合影'] },
        { 'photo': whitespace, 'width': 5, 'cations': [] },
        { 'photo': staff3, 'width': 288, 'cations': ['公司全体员工及部分家属巴厘岛旅行'] },
    ]
    const staffPhotos2 = [
        { 'photo': staff4, 'width': 291, 'cations': [] },
        { 'photo': whitespace, 'width': 5, 'cations': [] },
        { 'photo': staff5, 'width': 615, 'cations': [] },
        { 'photo': whitespace, 'width': 5, 'cations': [] },
        { 'photo': staff6, 'width': 288, 'cations': ['郝总拜访中国证监会首任主席刘鸿儒'] },
    ]
    const staffPhotos3 = [
        { 'photo': staff7, 'width': 589, 'cations': ['蔡奇书记视察丽泽金融圈'] },
        { 'photo': whitespace, 'width': 10, 'cations': [] },
        { 'photo': staff8, 'width': 605, 'cations': [] }
    ]

    return <div className={'sy-normal'}>
        <div style={{ position: 'relative', height: '62rem' }}>
            <CenterBox style={{ top: '14rem' }}>
                <ContentSpan style={{ marginTop: '12rem', marginRight: '5rem', width: '46rem', lineHeight: '4rem' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;企业简介：北京远见未来信息科技有限公司始创于2016年6月6日，我们的愿景是<GoldenSpan>成为中国顶级的金融数字内容服务提供商</GoldenSpan>，始终坚守“让金融更轻松”的使命，核心团队拥有二十年专业金融内容生产运营经验。通过多维度内容管理运营让金融机构企业价值、品牌、产品及以多种媒介形态呈现给机构客户，让触达及转化更简单轻松。</ContentSpan>
                <img src={glassbuilding} alt={'Glass Building'} />
            </CenterBox>
            <SectionTitle top={'8rem'} title={'企业简介'} subTitleLeft={'COMPANY'} subTitleRight={'PROFILE'} />

            {/* <SectionTitle top={'69rem'} title={'VI标识'} subTitleLeft={'VISUAL'} subTitleRight={'RECOGNITION SYSTEM'} />
            <img src={visionvalueblacklarge} alt={'VISION VALUE'} style={{ position: 'absolute', left: '46.7rem', top: '93.3rem', objectFit: 'cover' }} />
            <ContentSpan style={{ position: 'absolute', left: '98rem', top: '85.6rem', width: '53rem', lineHeight: '3rem' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<GoldenSpan>标志释义：</GoldenSpan>LOGO灵感来源于5W1H分析法，由六条线段六种颜⾊组成，加上VISION VALUE英⽂⾸字⺟V V 最终组成该LOGO主图形。⽂字部分通过字体设计⽽来，整体⻛格显沉稳、可靠、诚信。</ContentSpan>
            <ContentSpan style={{ position: 'absolute', left: '98rem', top: '100rem', width: '53rem', lineHeight: '3rem' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<GoldenSpan>基础LOGO：</GoldenSpan>独特的VV样式作为主图形，分为六个部分，代表了了5W1H(WHEN)、何地(WHERE)、何人（WHO）、何事(WHAT)、何故(WHY)、如何（HOW）。传递出远⻅见未来专注的品牌价值，凸显出远⻅未来沉稳、可靠、诚信。</ContentSpan> */}
        </div>

        <div style={{ position: 'relative', height: '84.4rem', backgroundColor: '#f6f6f6' }}>
            <SectionTitle top={'9.9rem'} title={'创始团队'} subTitleLeft={'SOUL'} subTitleRight={'FIGURE'} />
            <CenterBox style={{ top: '24.6rem', justifyContent: 'space-around', padding: '0 12%' }}>
                <SoulFigureSummary img={COO} name={'联合创始人＆COO'} title={'郝鹏州'} content={'20年财经视频媒体经验，CCTV财经频道主编，参与主办、创办《中国证券》、《交易时间》、《财经周刊》等节目，担任CCTV中国上市公司峰会论坛总导演，大型纪录片《中国股市记忆》总导演、三集大型纪录片《国债期货》总导演。'} />
                <SoulFigureSummary img={CEO} name={'创始人＆CEO'} title={'赵鑫'} content={'20年财经视频媒体经验，CCTV财经频道频道统筹《对话》节目总导演，参与主办、创办《中国证券》《理财123》、“CCTV中国创业榜样”、“中国公司榜”等节目，央视财经论坛总导演、《华商领袖》系列总策划。财经频道统筹，完成频道级别“全国两会”、“全球达沃斯论坛”、“世界互联网大会”等重大报道任务。协助频道总监管理财经频道节目生产、制作、运营、传播等各环节。'} />
                <SoulFigureSummary img={CCO} name={'联合创始人＆CCO'} title={'王先天'} content={'毕业于中央财经大学，央视财经频道《交易时间》《市场分析室》责编，10年财经节目制作经验，具备丰富的专业直播内容技术搭建、内容生产经验。'} />
            </CenterBox>
        </div>

        <div style={{ position: 'relative', height: '91.5rem' }}>
            <SectionTitle top={'9.9rem'} title={'企业文化'} subTitleLeft={'CORPORATE'} subTitleRight={'CULTURE'} />
            <CenterBox style={{ top: '28rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <img src={culture} alt={''} style={{ objectFit: 'cover' }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2rem 4rem' }}>
                        <div style={{ width: '42.7rem' }}>
                            <h3>愿景</h3>
                            <div>成为中国顶级的金融数字内容服务提供商</div>
                        </div>
                        <div style={{ width: '38.2rem' }}>
                            <h3>使命</h3>
                            <div>让金融更轻松</div>
                        </div>
                        <div>
                            <h3>价值观</h3>
                            <div>客户至上、激情创新、真诚团结、奋斗成长</div>
                        </div>
                    </div>
                </div>
            </CenterBox>
            <CenterBox style={{ top: '71rem', justifyContent: 'flex-start', padding: '0 20.8%' }}>
            </CenterBox>
        </div>

        <div style={{ position: 'relative', height: '84.6rem' }}>
            <CenterBox style={{ top: '0rem' }}>
                <img src={history} alt={'History'} style={{ objectFit: 'cover', width: '192rem', marginLeft: '4rem', marginTop: '-1rem' }} />
            </CenterBox>
            <SectionTitle top={'7rem'} title={'发展历程'} subTitleLeft={'DEVELOPMENT'} subTitleRight={'HISTORY'} titleColor={'white'} />
        </div>

        <div style={{ position: 'relative', height: '125rem' }}>
            <SectionTitle top={'9.9rem'} title={'员工风采'} subTitleLeft={'STAFF'} subTitleRight={'STYLE'} />
            <CenterBox style={{ top: '25rem', flexDirection: 'column' }}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    {
                        staffPhotos1.map((sf, index) => <PhotoFrame style={{ marginBottom: '0.5rem' }} photo={sf.photo} captions={sf.cations} width={sf.width} key={index} />)
                    }
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    {
                        staffPhotos2.map((sf, index) => <PhotoFrame style={{ marginBottom: '0.5rem' }} photo={sf.photo} captions={sf.cations} width={sf.width} key={index} />)
                    }
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    {
                        staffPhotos3.map((sf, index) => <PhotoFrame style={{ marginBottom: '0.5rem' }} photo={sf.photo} captions={sf.cations} width={sf.width} key={index} />)
                    }
                </div>
            </CenterBox>
        </div>
    </div>
}
